import { css } from '@emotion/react';
import { textMediumFontSize } from 'styles/global_defaults/fonts';

import { SanitizationLevel } from 'froala/helpers/sanitizer';
import { doubleModalZIndex } from 'shared/components/nv-modal';

import NvAthenaFroala from 'athena/components/nv-athena-froala';
import { FroalaViewMode } from 'froala/helpers/nv-froala-constants';
import { useFormContext } from 'react-hook-form';
import { danger } from 'styles/global_defaults/colors';

const styles = css`
  .froala-style-regular {
    font-size: ${textMediumFontSize}px;
  }

  &.error {
    .fr-element {
      outline: 1px solid ${danger} !important;
      outline-offset: 0 !important;
      border: none !important;
    }
  }
`;

const overlayStyles = css`
  z-index: ${doubleModalZIndex};
`;

const MentorRequestMessageInput = () => {
  const { formState } = useFormContext();
  const { errors } = formState;
  const hasError = !!errors.message;

  return (
    <NvAthenaFroala
      withForm
      css={styles}
      name='message'
      overlayStyles={overlayStyles}
      className={`mb-5 text-large-body ${hasError ? 'error' : ''}`}
      sanitizationLevel={SanitizationLevel.PLAIN}
      preset={FroalaViewMode.AIR}
      allowToolbar={false}
    />
  );
};

export default MentorRequestMessageInput;
